/*
 * @Descripttion:
 * @version:
 * @Author: suiyue
 * @Date: 2021-05-19 14:33:03
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-22 10:21:53
 */
import { CloseCircleOutlined, SettingOutlined } from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Checkbox,
  Col,
  Divider,
  Dropdown,
  Form,
  Input,
  InputProps,
  notification,
  Radio,
  Row,
  Select,
  Tag,
} from 'antd'
import React, {
  ReactElement,
  useContext,
  useState,
  useRef,
  useEffect,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ThemeContext } from '../../../../theme/ThemeContext'
import { RootDispatch } from '../../../../app/store'
import styles from './columns.module.css'

interface RecipeItemInputProps {
  value?: any
  style?: React.CSSProperties
  onChange?: (value: any) => void
  onBlur?: () => void
  medicalRecord?: any
  placeholder?: any
}

export const HistoricalEpidemiologyFastInput = ({
  value,
  style,
  onChange,
  onBlur,
  medicalRecord,
  placeholder,
}: RecipeItemInputProps &
  Pick<InputProps, 'onBlur' | 'onPressEnter'>): ReactElement => {
  const inputRef = useRef<any>()

  const [form] = Form.useForm()

  const { CheckableTag } = Tag

  const theme = useContext(ThemeContext)

  const dispatch = useDispatch<RootDispatch>()

  const [isVisible, setIsVisible] = useState(false)

  const [selectionStartIndex, setSelectionStartIndex] = useState<any>()

  const [selectionEndIndex, setSelectionEndIndex] = useState<any>()

  const [list, setList] = useState<any>()  //弹窗展示的内容

  const [days, setDays] = useState<any>(7) //天数，默认是7天

  const [pepoleLables, setPepoleLables] = useState<any>() //流掉对象默认患者

  const [checkedList, setCheckedList] = useState<any>([]) // 选中后的项目

  useEffect(() => {
    if (isVisible) {
      if (!value) {
        form.setFieldsValue({
          caseInvestigationOfDiseases: 1,
          caseInvestigationOfPeoples: [],
          caseInvestigationOfTime: 7,
        })
        setAllList(1, 7)

      } else {
        const resultJson = JSON.parse(value);
        setCheckedList(resultJson?.checkedList);
        form.setFieldsValue({
          caseInvestigationOfDiseases: resultJson?.caseInvestigationOfDiseases || 1,
          caseInvestigationOfPeoples: resultJson?.caseInvestigationOfPeoples || [],
          caseInvestigationOfTime: resultJson?.caseInvestigationOfTime || 7,
        })
        setList(resultJson?.checkedList)
        setDays(resultJson?.caseInvestigationOfTime || 7)
        handlePeopleChange(resultJson?.caseInvestigationOfPeoples)
      }
    }
  }, [isVisible])

  useEffect(() => {
    if (isVisible && list?.length) {
      setCheckedList(list)
    }
  }, [list])

  const caseInvestigationOfDiseasesOptions = [
    {
      label: '通用',
      value: 1,
    },
    {
      label: '基孔肯雅热',
      value: 2,
    },
    {
      label: '登革热',
      value: 3,
    },
  ]

  const timeList = [
    {
      label: '7天',
      value: 7,
    },
    {
      label: '14天',
      value: 14,
    },
    {
      label: '21天',
      value: 21,
    },
    {
      label: '28天',
      value: 28,
    },
  ]

  const normalList = (days: number) => [
    {
      label: '天内是否有中高风险地区或病例报告地区的旅行或居住史',
      value: 'normalOne',
    },
    {
      label: '天内是否接触过确诊病例、无症状感染者或来自疫情严重地区的人员',
      value: 'normalTwo',
    },
    {
      label: '天内是否参加大型聚集性活动（如会议、婚宴等）',
      value: 'normalThree',
    },
    {
      label: '天内是否是否到过医院、农贸市场、商场等高风险场所',
      value: 'normalFour',
    },
    {
      label: '天内是否出现发热、咳嗽、乏力等疑似症状',
      value: 'normalFive',
    }

  ]

  const KJKYRList = (days: number) => [
    {
      label: '天内是否到过基孔肯雅热/登革热疫区（如佛山、云南西双版纳、东南亚/南亚/非洲/美洲热带地区等）',
      value: 'KJKYROne',
    },
    {
      label: '天内是否被蚊虫叮咬（尤其白昼时段伊蚊叮咬史）',
      value: 'KJKYRTwo',
    },
    {
      label: '天内是否出现发热（37.3°C)伴关节痛（小关节对称性肿痛）与皮疹（充血性皮疹与出血点）',
      value: 'KJKYRThree',
    },
    {
      label: '天内是否出现头痛/眼眶痛/肌肉痛/乏力/恶心等登革热交叉症',
      value: 'KJKYRFour',
    },
    {
      label: '天内是否未使用驱蚊产品（避蚊胺≥20%浓度）',
      value: 'KJKYRFive',
    },
    {
      label: '居住/工作场所周围是否有基孔肯雅热/登革热病例',
      value: 'KJKYRFSix',
    }
  ]

  const DGRList = (days: number) => [
    {
      label: '天内是否有到过登革热流行区的旅居史（如东南亚、西太平洋地区等热带或亚热带地区）',
      value: 'DGROne',
    },
    {
      label: '天内是否有蚊虫、蜱虫叮咬史',
      value: 'DGRTwo',
    },
    {
      label: '天内是否接触过发热、皮疹或确诊登革热的患者',
      value: 'DGRThree',
    },
    {
      label: '居住/工作场所周围是否有基孔肯雅热/登革热病例',
      value: 'DGRFour',
    }
  ]

  // 流调对象切换
  const handlePeopleChange = (v: number[]) => {
    if (v?.length === 1) {
      setPepoleLables(v[0] === 1 ? '患者' : '陪同者')
    } else if (v?.length === 2) {
      setPepoleLables('患者（及陪同者）')
    }
  }

  // 传入到输入框
  const handleChangeByChecdkList = (checkData: any) => {
    setCheckedList(checkData)

    // 将选中的结果按照点击顺序拼接成字符串
    if (checkData && checkData.length > 0) {
      const resultText = checkData?.map((item: any) => {
        if (item.checked) {
          return item.value != 'KJKYRFSix' && item.value !== 'DGRFour' ? `${days}${item.label}（${item.checked}）；` : `${days}${item.label}（${item.checked}）；`;
        }
      }).join('')
      // 只有当resultText有实际内容时才调用onChange，避免触发必填校验
      if (resultText) {
        // 全部文本
        const fullText = pepoleLables ? `${pepoleLables}：${resultText}` : resultText;
        // 表单域
        const result = {
          fullText: fullText,
          ...form.getFieldsValue(),
          checkedList: checkData
        }
        onChange && onChange(JSON.stringify(result));
      }
    }
  }
  // 传入到输入框
  const handleChangeByDays = (byDays: any) => {
    setDays(byDays);
    // 将选中的结果按照点击顺序拼接成字符串
    if (checkedList && checkedList.length > 0) {
      const resultText = checkedList?.map((item: any) => {
        if (item.checked) {
          return item.value != 'KJKYRFSix' && item.value !== 'DGRFour' ? `${byDays}${item.label}（${item.checked}）；` : `${byDays}${item.label}（${item.checked}）；`;
        }
      }).join('')
      // 只有当resultText有实际内容时才调用onChange，避免触发必填校验
      if (resultText) {
        // 全部文本
        const fullText = pepoleLables ? `${pepoleLables}：${resultText}` : resultText;
        // 表单域
        const result = {
          fullText: fullText,
          ...form.getFieldsValue(),
          checkedList
        }
        onChange && onChange(JSON.stringify(result));
      }
    }
  }


  // 传入到输入框
  const handleChangeByPeopleChange = (peopleV: any) => {
    let peopleStr = "";
    if (peopleV?.length == 1) {
      peopleStr = peopleV[0] == 1 ? '患者' : '陪同者';
    } else if (peopleV?.length == 2) {
      peopleStr = '患者（及陪同者）';
    }
    setPepoleLables(peopleStr)

    // 将选中的结果按照点击顺序拼接成字符串
    if (checkedList && checkedList.length > 0) {
      const resultText = checkedList?.map((item: any) => {
        if (item.checked) {
          return item.value != 'KJKYRFSix' && item.value !== 'DGRFour' ? `${days}${item.label}（${item.checked}）；` : `${days}${item.label}（${item.checked}）；`;
        } else {
          return ' ';
        }
      }).join('')
      // 只有当resultText有实际内容时才调用onChange，避免触发必填校验
      if (resultText) {
        // 全部文本
        const fullText = peopleStr ? `${peopleStr}：${resultText}` : resultText;
        // 表单域
        const result = {
          fullText: fullText,
          ...form.getFieldsValue(),
          checkedList
        }
        onChange && onChange(JSON.stringify(result));
      }
    }
  }

  const layout = {
    labelCol: { span: 10 },
    wrapperCol: { span: 14 },
  }

  // 流调病症 切换设置数组
  const setAllList = (v: number, days?: number) => {
    if (v == 1) {
      setList(normalList(days || 7))
    } else if (v == 2) {
      setList(KJKYRList(days || 7))
    } else if (v == 3) {
      setList(DGRList(days || 7))
    } else {
      setList(normalList(days || 7))
    }
  }

  const overlay = (
    <div className={styles.overlay}>
      <div
        style={{
          padding: '0 15px',
        }}
      >
        <Form form={form}>
          <Row className={styles.firstLine}>
            <Row style={{ display: 'flex', justifyContent: 'space-between', width: '86%' }}>
              <Form.Item name='caseInvestigationOfDiseases' label='流调病症' noStyle>
                <Select style={{ width: '110px' }} placeholder='请选择' allowClear={false}
                  onChange={(v) => {
                    setAllList(v, days || 7)
                  }
                  }>
                  {caseInvestigationOfDiseasesOptions.map((item) => (
                    <Select.Option key={item.value} value={item.value}>
                      {item.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item name='caseInvestigationOfPeoples' label='流调对象' noStyle>
                <Checkbox.Group
                  style={{}}
                  onChange={(v: any) => {
                    // handlePeopleChange(v)
                    handleChangeByPeopleChange(v);
                  }}>
                  <Checkbox value={1}>患者</Checkbox>
                  <Checkbox value={2}>陪同者</Checkbox>
                </Checkbox.Group>
              </Form.Item>
              <Form.Item name='caseInvestigationOfTime' label='流调时间' noStyle>
                <Select style={{ width: '110px' }} placeholder='请选择' allowClear={false} onChange={(v) => {
                  handleChangeByDays(v || 7)
                }}>
                  {timeList.map((item: any) => (
                    <Select.Option key={item.value} value={item.value}>
                      {item.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Row>
            <div className={styles.confirmButton} style={{ width: '14%' }}>
              <Button type='primary' ghost onClick={() => {
                const list = checkedList?.map((v: any) => {
                  return {
                    ...v,
                    checked: '否',
                  }
                })
                handleChangeByChecdkList(list)
                setIsVisible(false)
              }}>确认全否</Button>
            </div>
          </Row>
          <div style={{ padding: '6px 0' }}>
            {list?.map((item: any) => {
              return (
                <Row key={item.value} className={styles.bottomLine}>
                  <Col span={19}>
                    <span>{item.value !== 'KJKYRFSix' && item.value !== 'DGRFour' ? days + item.label : item.label}</span>
                  </Col>
                  <Col span={5} className={styles.rightContent}>
                    <Form.Item name={item.value} >
                      {['是', '否'].map((tag) => (
                        <CheckableTag
                          key={tag}
                          checked={checkedList?.find((v: any) => v.value == item.value)?.checked == tag}
                          onChange={(checked: any) => {
                            const checkData = checkedList?.map((v: any) => {
                              return {
                                ...v,
                                checked: v.value == item.value ? (checked ? (tag === '是' ? '是' : '否') : '') : v.checked,
                              }
                            })
                            handleChangeByChecdkList(checkData)
                          }}
                        >
                          {tag}
                        </CheckableTag>
                      ))}
                    </Form.Item>
                  </Col>
                </Row>)
            })
            }</div>
        </Form>
      </div>
      <Row
        justify='center'
        align='middle'
        className={styles.closeButton}
        style={{
          color: theme.c1,
        }}
        onClick={() => {
          setIsVisible(false)
        }}
      >
        <div>
          <CloseCircleOutlined />
          &ensp; 关 闭
        </div>
      </Row>
    </div >
  )

  return (
    <>
      <Dropdown
        overlay={overlay}
        visible={isVisible}
        trigger={['click']}
        overlayStyle={{
          width: 400,
          boxShadow:
            ' 0 3px 6px -4px rgb(0 0 0 / 12%), 0 6px 16px 0 rgb(0 0 0 / 8%), 0 9px 28px 8px rgb(0 0 0 / 5%)',
        }}
        placement='bottomCenter'
        align={{
          overflow: {
            adjustX: false,
            adjustY: false,
          },
        }}
        getPopupContainer={(triggerNode: any) => triggerNode.parentNode}
        onVisibleChange={(visible) => setIsVisible(visible)}
      >
        <Input.TextArea
          ref={inputRef}
          autoSize
          placeholder={placeholder ? placeholder : '请输入内容'}
          value={value ? JSON.parse(value)?.fullText : ""}
          style={style}
          onClick={(e: any) => {
            const startPos = e.target.selectionStart // 获取鼠标点击时的光标位置
            const endPos = e.target.selectionStart // 获取鼠标点击时的光标位置
            if (e.target.selectionStart == value?.length) {
              setSelectionStartIndex(0)
            } else {
              setSelectionStartIndex(startPos)
            }
            setSelectionEndIndex(endPos)

            if (!e.target.value) {
              setIsVisible(true)
            }
          }}
          onChange={(e) => {
            const result = {
              fullText: e.target.value,
              ...form.getFieldsValue(),
              checkedList
            }
            onChange && onChange(JSON.stringify(result))
            setIsVisible(false)
          }}
          onBlur={() => {
            onBlur && onBlur()
          }}
        />
      </Dropdown>

    </>
  )
}